import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { MaterialModule } from '../material/material.module';
import { ListItemComponent } from './components/list-item/list-item.component';
import { CardComponent } from './components/card/card.component';
import { CardHeaderComponent } from './components/card/card-header.component';
import { CardContentComponent } from './components/card/card-content.component';
import { DoubleScrollerComponent } from './components/double-scroller/double-scroller.component';
import { OutputListenersPipe } from './pipes/output-listeners.pipe';
import { FallbackPipe } from './pipes/fallback.pipe';
import { SharedRoutingModule } from './shared-routing.module';
import { TranslationModule } from '@examsoft/translation';
import { SafePipe } from './pipes/safe.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SwitchProfileModalComponent } from 'src/app/shared/components/switch-profile-modal/switch-profile-modal.component';
import { CookieService } from './services/cookie.service';

@NgModule({
  declarations: [
    OutputListenersPipe,
    HeaderComponent,
    ListItemComponent,
    CardComponent,
    CardHeaderComponent,
    CardContentComponent,
    DoubleScrollerComponent,
    FallbackPipe,
    SafePipe,
    SafeHtmlPipe,
    SwitchProfileModalComponent,
  ],
  imports: [SharedRoutingModule, CommonModule, MaterialModule, TranslationModule],
  exports: [
    OutputListenersPipe,
    HeaderComponent,
    CardComponent,
    CardHeaderComponent,
    CardContentComponent,
    DoubleScrollerComponent,
    FallbackPipe,
    SafePipe,
    SafeHtmlPipe,
    SwitchProfileModalComponent,
  ],
  providers: [CookieService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
